export const T = {
  en_GB: {
    title: "Validation & Capacity Settings",
    description:
      "Business rules applied when this model is used in a flow. All settings are off by default.",
    oneFieldInAssetsRequired: "Require at least one asset",
    oneFieldInAssetsRequiredHelp:
      "The financial situation is incomplete until at least one asset entry with an amount is added.",
    oneFieldInLiabilitiesRequired: "Require at least one liability",
    oneFieldInLiabilitiesRequiredHelp:
      "The financial situation is incomplete until at least one liability entry with an amount is added.",
    expectingChanges: "Expecting-changes question",
    expectingChangesHelp:
      'Adds a required "Are you expecting changes to your financial situation?" question; a note is required when the answer is yes.',
    capacityHeading: "Investment capacity calculator",
    capacityHelp:
      "Adds a Capacity section: monthly income/expenses/surplus, a liquidity buffer with a calculated minimum, and the amount available for investments.",
    validateDeposits: "Block deposits above capacity",
    validateDepositsHelp:
      "The flow cannot be completed while one-time deposits exceed the amount available for investments or monthly deposits exceed the monthly surplus.",
    enabled: "Enabled",
    bufferFloor: "Buffer floor",
    bufferFloorHelp: "Absolute minimum liquidity buffer.",
    bufferFloorGroup: "Buffer floor (per member)",
    bufferFloorHelpGroup:
      "Minimum liquidity buffer per group member — multiplied by the number of members in the group.",
    bufferMultiplier: "Buffer multiplier",
    bufferMultiplierHelp: "Months of monthly income the buffer must cover.",
    bufferMultiplierHelpExpenses: "Months of monthly expenses the buffer must cover.",
    inputFrequency: "Input values",
    inputFrequencyHelp:
      "Monthly: enter any two of income, expenses and surplus. Annual: enter annual income and expenses; the monthly surplus is calculated.",
    inputFrequencyMonthly: "Monthly",
    inputFrequencyAnnual: "Annual",
    multiplierBasis: "Multiplier based on",
    multiplierBasisHelp: "The monthly figure the buffer multiplier is applied to.",
    multiplierBasisIncome: "Income",
    multiplierBasisExpenses: "Expenses",
    fixedBuffer: "Fixed buffer client field",
    fixedBufferHelp:
      "When the client has this yes/no field ticked, the fixed amount below becomes their liquidity buffer and the multiplier and floor no longer apply.",
    fixedBufferNone: "No fixed buffer",
    fixedBufferAmount: "Fixed buffer amount",
    fixedBufferAmountRequired: "Enter a fixed buffer amount above zero, or clear the client field.",
    fixedBufferStaleSelection: "Client field no longer available",
    fixedBufferStale:
      'The selected client field no longer exists, so the fixed buffer is not being applied. Pick another field, or select "No fixed buffer" to clear the setting.',
    noBooleanClientFields: "No yes/no client fields — add one in the client field settings first.",
    shortTermExpenses: "Short-term expenses field",
    shortTermExpensesHelp: "Adds an input for near-term spending, subtracted from capacity.",
    assetFields: "Investable asset fields",
    assetFieldsHelp:
      "The asset fields summed into the investable pool. Save new fields first to select them here.",
    assetFieldsRequired: "Select at least one asset field for each enabled variant.",
    noAssetFields: "No applicable asset fields — add asset fields above and save first.",
    save: "Save",
    saved: "Saved",
    error: "Error",
    failedToSave: "Failed to save",
  },
  nb_NO: {
    title: "Validerings- og kapasitetsinnstillinger",
    description:
      "Forretningsregler som gjelder når denne modellen brukes i en flyt. Alle innstillinger er av som standard.",
    oneFieldInAssetsRequired: "Krev minst én eiendel",
    oneFieldInAssetsRequiredHelp:
      "Den økonomiske situasjonen er ufullstendig til minst én eiendelspost med beløp er lagt til.",
    oneFieldInLiabilitiesRequired: "Krev minst én gjeldspost",
    oneFieldInLiabilitiesRequiredHelp:
      "Den økonomiske situasjonen er ufullstendig til minst én gjeldspost med beløp er lagt til.",
    expectingChanges: "Spørsmål om forventede endringer",
    expectingChangesHelp:
      'Legger til et obligatorisk spørsmål "Forventer du endringer i din økonomiske situasjon?"; et notat kreves ved ja.',
    capacityHeading: "Investeringskapasitetskalkulator",
    capacityHelp:
      "Legger til en kapasitetsseksjon: månedlig inntekt/utgifter/overskudd, likviditetsbuffer med beregnet minimum, og beløp tilgjengelig for investering.",
    validateDeposits: "Blokker innskudd over kapasitet",
    validateDepositsHelp:
      "Flyten kan ikke fullføres mens engangsinnskudd overstiger tilgjengelig investeringsbeløp eller månedlige innskudd overstiger månedlig overskudd.",
    enabled: "Aktivert",
    bufferFloor: "Buffergulv",
    bufferFloorHelp: "Absolutt minste likviditetsbuffer.",
    bufferFloorGroup: "Buffergulv (per medlem)",
    bufferFloorHelpGroup:
      "Minste likviditetsbuffer per gruppemedlem — multipliseres med antall medlemmer i gruppen.",
    bufferMultiplier: "Buffermultiplikator",
    bufferMultiplierHelp: "Antall måneder med månedsinntekt bufferen må dekke.",
    bufferMultiplierHelpExpenses: "Antall måneder med månedlige utgifter bufferen må dekke.",
    inputFrequency: "Inndataverdier",
    inputFrequencyHelp:
      "Månedlig: fyll inn to av inntekt, utgifter og overskudd. Årlig: fyll inn årlig inntekt og utgifter; månedlig overskudd beregnes.",
    inputFrequencyMonthly: "Månedlig",
    inputFrequencyAnnual: "Årlig",
    multiplierBasis: "Multiplikator basert på",
    multiplierBasisHelp: "Månedsbeløpet buffermultiplikatoren brukes på.",
    multiplierBasisIncome: "Inntekt",
    multiplierBasisExpenses: "Utgifter",
    fixedBuffer: "Klientfelt for fast buffer",
    fixedBufferHelp:
      "Når klienten har krysset av for dette ja/nei-feltet, blir beløpet under likviditetsbufferen, og multiplikator og gulv gjelder ikke lenger.",
    fixedBufferNone: "Ingen fast buffer",
    fixedBufferAmount: "Fast bufferbeløp",
    fixedBufferAmountRequired: "Angi et fast bufferbeløp over null, eller fjern klientfeltet.",
    fixedBufferStaleSelection: "Klientfeltet er ikke lenger tilgjengelig",
    fixedBufferStale:
      "Det valgte klientfeltet finnes ikke lenger, så den faste bufferen brukes ikke. Velg et annet felt, eller velg «Ingen fast buffer» for å fjerne innstillingen.",
    noBooleanClientFields:
      "Ingen ja/nei-klientfelt — legg til ett i klientfeltinnstillingene først.",
    shortTermExpenses: "Felt for kortsiktige utgifter",
    shortTermExpensesHelp:
      "Legger til et felt for forbruk i nær fremtid som trekkes fra kapasiteten.",
    assetFields: "Investerbare eiendelsfelt",
    assetFieldsHelp:
      "Eiendelsfeltene som summeres til investerbar kapital. Lagre nye felt først for å kunne velge dem her.",
    assetFieldsRequired: "Velg minst ett eiendelsfelt for hver aktiverte variant.",
    noAssetFields: "Ingen aktuelle eiendelsfelt — legg til eiendelsfelt over og lagre først.",
    save: "Lagre",
    saved: "Lagret",
    error: "Feil",
    failedToSave: "Kunne ikke lagre",
  },
} as const;
